export const appsAppGroupIdChartsPurchaseNames = "/apps/:app_group_id/charts/purchase_names";
